
<template>
  <div 
    class="event-title overflow-x-hidden"  
    :style="{
      'background-color': event.backgroundColor,
      width: '100%',
      color: event.backgroundColor === '#FFFFFF' ? 'black' : '#fff',
    }"
  >
    <div class="event-time">{{ `${event.extendedProps.timeStart12HourFormat} - ${event.extendedProps.timeEnd12HourFormat}` }}</div>
    <div class="event-staff">{{ event.extendedProps.name }}</div>
    <div class="event-client">{{ event.extendedProps.clientNameText | removeUnwantedChars }}</div>
    <div class="event-program">{{ event.extendedProps.programName }}</div>
    <div class="event-color">{{ event.color }}</div>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  props: {
    event: Object,
  },
  methods: {
    cleanData(data){
      return data;
    }
  }

  
};

Vue.filter('removeUnwantedChars', function(value) {
  if(value)
  // Use regular expressions or any logic to remove unwanted characters
  return value.replace(/[^\w\s]/gi, ', '); // Removes non-alphanumeric characters
});

</script>

<style scoped>
/* Add your styling here if needed */
  .event-title{
    padding-left: 10px;
  }
</style>